import { actions } from '../constants'

const initialState = {
  loading: false,
  data: [],
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.FETCH:
      return {
        ...state,
        loading: true,
      }

    case actions.FETCH_SUCCESS:
      return {
        loading: false,
        data: payload,
      }

    case actions.FETCH_FAILURE:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}

export default reducer
